<template>
  <div v-if="Object.keys(drawInfo).length > 0" class="content-7__lottery">
    <div class="content-7__lottery__icon">
      <img class="lottery-img" :src="lotteryDetail.iconURL" alt="彩种icon">
    </div>
    <div class="content-7__lottery__content">
      <div class="lotterybox">
        <div class="lotterybox__lottery-name">
          <span class="lotterybox__lottery-name__text">{{ lotteryDetail.name }}</span>
        </div>
        <div class="lotterybox__lottery-datenumber">
          <span class="lotterybox__lottery-datenumber__number" v-text="periodLabel"></span>
          <span class="lotterybox__lottery-datenumber__text">期</span>
        </div>
        <div class="lotterybox__lottery-detail">
          <span v-if="categoryCode === 'local' || categoryCode === 'china'" class="lotterybox__lottery-detail__text">开奖星期: {{ formatWeek(lotteryDetail.weekdays) }}</span>
          <span v-if="categoryCode === 'gaopin' || categoryCode === 'jisu'" class="lotterybox__lottery-detail__text">开奖频率: {{ formatSeconds(lotteryDetail.intervalSeconds) }}分</span>
          <span v-if="lotteryDetail.closeDay" class="lotterybox__lottery-detail__text">休市: {{ lotteryDetail.closeDay }}</span>
        </div>
        <div v-if="hasRulePopup" class="lottery-title__explanation">
          <a class="button-outline" @click="openDescription">
            <span class="button-outline__text">玩法说明</span>
          </a>
        </div>
      </div>
      <div class="lottery-ballbox">
        <div v-if="lotteryType === 'pk10'" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <div
                class="ball size-large"
                :class="{
                  [`ball-0${ball}`]: ball !== 10,
                  'ball-10': ball === 10,
                }"
              >
                <span class="ball__number">{{ ball }}</span>
              </div>
            </div>
          </template>
        </div>
        <div v-if="(lotteryType === 'ssc' || lotteryType === '11x5' || lotteryType === 'kl8' || lotteryType === 'kl10') && (lotteryCode !== 'cqxync') && (lotteryCode !== 'cqssc')" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <div class="ball color--primary size-large circle">
                <span class="ball__number">{{ ball }}</span>
              </div>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'k3'" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <img :src="require(`@/assets/desktop/img/ball/dice/dice${ball}@1.5x.png`)" alt="">
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'xy28'" class="ballbox">
          <div class="ball color--primary size-large circle">
            <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[0]', 0) }}</span>
          </div>
          <div class="ballbox__item">
            <img src="@/assets/desktop/img/plus.svg" alt="">
          </div>
          <div class="ball color--primary size-large circle">
            <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[1]', 0) }}</span>
          </div>
          <div class="ballbox__item">
            <img src="@/assets/desktop/img/plus.svg" alt="">
          </div>
          <div class="ball color--primary size-large circle">
            <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
          </div>
          <div class="ballbox__item">
            <img src="@/assets/desktop/img/equal.svg" alt="">
          </div>
          <div class="ball color--red size-large circle">
            <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[0]', 0) + get(drawInfo, 'prePeriod.balls[1]', 0) + get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
          </div>
        </div>
        <div v-if="lotteryCode === 'cqxync'" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <div class="ball size-large" :class="`haomaimg-${ball}`"></div>
            </div>
          </template>
        </div>
        <div v-if="lotteryCode === 'cqssc'" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <div class="ball size-large" :class="`zodiac-${ball}`"></div>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'others'" class="ballbox">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="ballbox__item">
              <div class="ball color--red size-large circle">
                <span class="ball__number">{{ ball }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="countdown">
      <div class="countdown__title">
        <span class="countdown__title__text">下期开奖</span>
      </div>
      <CounterDown
        :draw-info="drawInfo"
        :lottery-code="lotteryCode"
        :category-code="categoryCode"
        @timeChange="timeChange($event)"
        @drawing="drawing($event)"
        @complete="complete($event)"
        @changeDrawInfo="changeDrawInfo($event)"
      />
    </div>

    <VideoContent
      v-if="!noVideo"
      :lottery-code="lotteryCode"
      :lottery-type="lotteryType"
      @click.native="openVideo"
    />

    <!-- 兩面專用 -->
    <div v-if="lmTjData" class="content-7-total">
      <div class="content-7-total__title">
        <span class="content-7-total__title__text">汇总</span>
        <span
          class="content-7-total__title__subtext"
          v-text="`日目标: ${lmTjData.todayTotalProfit + lmTjData.profitDiffToGoal}`"
        ></span>
      </div>
      <div class="content-7-total__content">
        <span class="content-7-total__content__text">今日累计:</span>
        <span class="content-7-total__content__subtext red" v-text="lmTjData.todayTotalProfit"></span>
        <span
          v-if="!lmTjData.dailyFinished"
          class="content-7-total__content__text"
          v-text="'距离目标:'"
        ></span>
        <span
          v-if="!lmTjData.dailyFinished"
          class="content-7-total__content__subtext red"
          v-text="lmTjData.profitDiffToGoal"
        ></span>
        <span v-if="lmTjData.dailyFinished" class="content-7-total__content__text red">目标已达成</span>
      </div>
    </div>

  </div>
</template>

<script>
import VideoContent from '@/components/web/common/VideoContent'
import { getDetailDrawInfo_desktop } from '@/api/desktop/basic'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import CounterDown from '@/components/web/common/CounterDown'
import get from 'lodash.get'

const weekMap = ['日', '一', '二', '三', '四', '五', '六']
export default {
  name: 'TrendLotteryItem',
  components: {
    VideoContent,
    CounterDown
  },
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('LotteryItem required key "lotteryCode"')
        return ''
      }
    },
    lmTjData: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      lotteryDetail: {},
      drawInfo: {},
      categoryCode: '',
      lotteryType: '',
      lotteryInfo: {}
    }
  },
  computed: {
    noVideo() {
      return this.lmTjData
    },
    periodLabel() {
      return get(this, 'drawInfo.prePeriod.period', '-')
    },
    hasRulePopup() {
      switch (this.lotteryCode) {
        case 'fcssq':
        case 'qlc':
        case 'cjdlt':
        case 'pl5':
        case 'qxc':
          return false
        default:
          return true
      }
    }
  },
  watch: {
    async lotteryCode() {
      await this.getLotteryType()
      this.getLotteryDetail()
      this.getDetailDrawInfo(this.lotteryCode)
    }
  },
  async created() {
    await this.getLotteryType()
    this.getLotteryDetail()
    this.getDetailDrawInfo(this.lotteryCode)
  },
  methods: {
    timeChange(event) {
      this.$emit('timeChange', event)
    },
    drawing(event) {
      this.$emit('drawing', event)
    },
    complete(event) {
      this.$emit('complete', event)
    },
    async getLotteryType() {
      this.lotteryType = await this.$getLotteryType(this.lotteryCode)
    },
    async getLotteryDetail() {
      const [publicCpMap, error] = await this.$store.dispatch('lottery/getLotteryMap')
      if (error) return

      this.lotteryDetail = publicCpMap[this.lotteryCode]
      this.getCategoryCode()
      this.getLotteryInfo()
    },
    async getDetailDrawInfo(code) {
      const [data, error] = await getDetailDrawInfo_desktop(code)
      if (error) return [null, error]

      this.$emit('complete', data[code])
      this.drawInfo = data[code]
    },
    getLotteryInfo() {
      this.lotteryInfo.lotteryCode = this.lotteryCode
      this.lotteryInfo.name = this.lotteryDetail.name
    },
    getCategoryCode() {
      this.categoryCode = this.lotteryDetail.categoryCode
    },
    formatWeek(weekArray) {
      return weekArray.length === 7 ? '每日' : weekArray.map(day => weekMap[day]).join('')
    },
    formatSeconds(seconds) {
      return seconds / 60
    },
    formatLot(value) {
      return ruleCodeMapping[value]
    },
    openVideo() {
      this.$store.commit('lottery/OPEN_VIDEO', this.lotteryInfo)
    },
    openDescription() {
      this.$store.commit('lottery/OPEN_DESCRIPTION', this.lotteryInfo)
    },
    changeDrawInfo(data) {
      this.drawInfo = data
    },
    get(obj = {}, query = '', defaultValue = '') {
      return get(obj, query, defaultValue)
    }
  }
}
</script>
